export default __webpack_public_path__ + "static/media/150.bbf7ac70.png";